import { configureStore } from '@reduxjs/toolkit';

import projectReducer from './projectSlice';

import blogReducer from './blogSlice';

export default configureStore({
    reducer: {
        project: projectReducer,
        blog: blogReducer,
    }
});